<template>
  <vx-card no-shadow class="p-3">
    <ASpin :spinning="loading_page" :indicator="indicator">
      <a-form @submit.prevent="handleAutomaticRemainder" :form="formTemplates">
        <div class="flex flex-col-reverse md:flex-row-reverse justify-between">
          <div class="space-x-2">
            <a-button type="primary" ghost @click="$emit('changeTab','UserSettingsConnections')" style="border-radius: 3px !important;">Cancel</a-button>
            <a-button type="primary" :loading="loading" html-type="submit" style="border-radius: 3px">Save Template</a-button>
          </div>
          <h3>Bill Setting</h3>
        </div>

        <a-divider orientation="left">Matter Reference</a-divider>
        <div class="flex flex-col md:flex-row gap-2">
          <a-form-item label="Matter Reference">
            <a-input
              v-decorator="['name',{ rules: [
                { required: true, message: 'Field cannot be empty.' },
                { pattern: /^.{1,8}$/, message: 'Field must be at most 8 characters.' },
                { pattern: /^[\w\d\-_#()]*$/, message: 'Field can only contain #, underscore, dash, parentheses, and alphanumeric characters.' },
              ] }]"
            />
          </a-form-item>
        </div>

        <a-divider orientation="left">Bill Template</a-divider>
        <div class="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
          <div v-for="template in templates" :key="template.item">
              <a-popover placement="topLeft" overlayClassName="popoverTemp" trigger="hover">
                <template slot="content">
                  <img
                    slot="cover"
                    :src="require('../../../../assets/images/template/' + template.img)"
                    loading="lazy"
                    height="500"
                    class="object-cover"
                  />
                </template>
                <a-card
                  class="card-temp w-full md:w-250"
                  v-if="template"
                  @click="selectTemp(template)"
                  hoverable
                  :class="{'border-4 rounded-xl border-color': (item_select && item_select === template.item && isActive )}"
                >
                  <img
                    slot="cover"
                    :src="require('../../../../assets/images/template/' + template.img)"
                    height="300"
                    loading="lazy"
                  />
                </a-card>
              </a-popover>
            </div>
        </div>
        <a-divider orientation="left">
          Firm logo
        </a-divider>
        <div class="flex flex-col md:flex-row gap-2">
          <a-form-item>
            <XUpload
              ref="avatar"
              url="/account/firm/avatar/"
              @input="avatarFirm"
              :hasRoundedImg="false"
              class="avatar-firm-logo"
            />
          </a-form-item>
          <vue-editor v-model="description" :editorToolbar="customToolbar" class="w-full h-full"></vue-editor>
        </div>
      </a-form>
    </ASpin>
  </vx-card>

</template>

<script>
import mixin from '../../../mixin/mixin'
import axios from "@/axios"
import SelectOption from "../../../forms/SelectOptionSingle"
import XUpload from "@/components/x-upload/XUpload"
// import { Vue2TinymceEditor } from "vue2-tinymce-editor"
import { VueEditor } from "vue2-editor"

export default {
  name: "Billing",
  mixins:[mixin],
  components:{
    SelectOption,
    XUpload,
    VueEditor
  },
  data(){
    return{
      is_enable_reminder: false,
      loading           : false,
      loading_page      : false,
      currency          : null,
      isActive          : false,
      reminder          : {},
      item_select       : null,
      avatar            : null,
      formTemplates     : this.$form.createForm(this, {name: 'coordinated'}),
      description       : null,
      templates:[
        { img:'template.png',item: 1 },
        { img:'template2.png',item: 2 },
        { img:'template3.png',item: 3 }
      ],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ]
    }
  },
  methods:{
    avatarFirm(url){
      this.avatar = url
    },
    selectTemp(template){
      this.item_select = template.item
      this.isActive    = true
    },
    handleAutomaticRemainder(){
      this.formTemplates.validateFields(async (err,values) => {
        if(!this.item_select){
          this.$message.error('Please select template bill')
          return
        }
        if(!this.avatar && !this.$refs.avatar.imageUrl){
          this.$message.error('Please upload Firm logo')
          return
        }

        if (!err) {
          try {
            this.loading    = true

            await axios.post('/dictionary/refcode/', values)

            const firmPayload = {}
            firmPayload.template = this.item_select
            firmPayload.avatar   = this.avatar || this.$refs.avatar.imageUrl
            if (this.description)
              firmPayload.description = this.description
            await axios.put('/setting/firm/',{ templates: firmPayload })
            this.$notification['success']({
              message: 'Success',
              description: `Bill settings success.`,
            });
            const user = JSON.parse(localStorage.getItem('user'))
            if (user) {
              this.$store.commit('UPDATE_PROFILE',{ ...user, firm_avatar_url: firmPayload.avatar })
              localStorage.setItem('user', JSON.stringify({ ...user, firm_avatar_url: firmPayload.avatar }))
            }
            this.$store.commit('settings/SET_TEMPLATE_TYPE', firmPayload.template)
            this.$router.push('/billing').catch(()=>{})
            // this.$emit('changeTab','UserSettingsConnections')
          } catch (e) {
            this.$notification['error']({
              message: 'failed',
              description: `Bill settings failed.`,
            });
          } finally {
            this.loading = false
          }
        }
      })
    },
    async getOneBill(){
      try{
        this.loading_page = true
        const { data } = await axios.get('/setting/firm/')
        if(data && data.setting && data.setting.templates){
          if(data.setting.templates.avatar) this.$refs.avatar.imageUrl = data.setting.templates.avatar
          this.item_select = data.setting.templates.template
          this.isActive    = true
          this.description = data.setting.templates.description
          this.formTemplates.setFieldsValue(data.setting.templates)
        }else{
          this.item_select =  1
          this.isActive    = true
        }
      }catch (e) {
        this.$message.error('Error receiving data.')
        throw e
      }finally {
        this.loading_page = false
      }
    },
  },
  async mounted() {
    this.getOneBill()

    try {
      const { data } = await axios.get('/dictionary/refcode/')
      if (data[data.length - 1].name)
        this.formTemplates.setFieldsValue(data[data.length - 1])
    } catch (e) {
    }
  }
}
</script>

<style>
  @import "../../../style/style.css";
  .ant-btn-link {
    color: #6065cc !important;
  }
  .ant-input-number{
    border-radius: 3px !important;
  }
  .border-color{
    border-color: #3A3DBE;
    background-color: #3A3DBE;
    position: relative;
    transition: all 0.5s cubic-bezier(0, 1.49, 0, 1.6)
  }
  [dir] .ant-divider-with-text-left{
    background: #ffffff !important;
  }
  .card-temp .ant-card-body{
    padding: 0 !important;
  }
  [dir] .ant-result{
    position: absolute;
    top: 15%;
    left: 0;
    right: 0;
  }
  .border-color:before{
    background-color: #ccc;
    opacity: 0.2;
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .popoverTemp .ant-popover-inner-content{
    padding: 0 !important;
  }
  .popoverTemp .ant-popover-arrow{
    left: 16px;
    top: -5px;
    transform: rotate(220deg);
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    display: none;
  }
  .avatar-firm-logo .ant-upload{
    width: 230px;
    height: 230px;
  }
  .avatar-firm-logo .ant-upload img{
    height: 200px;
  }
</style>
